<div [formGroup]="form" *ngIf="isVisible">
  <div class="row" formArrayName="documents">
    <ng-container
      *ngFor="let documentCtrl of documents.controls; let i = index"
    >
      <div
        class="pr-2"
        [ngClass]="
          documents.controls.length % 2 != 0 &&
          i == documents.controls.length - 1
            ? 'col-12 '
            : 'col-md-6 '
        "
      >
        <div class="p-relative border-dashed p-4 rounded mt-4">
          <button
            class="btn-remove"
            (click)="deleteControl(i)"
            [disabled]="documents.length == 1"
          >
            <i class="icon icon-delete"></i>
          </button>
          <file-uploader
            [maxSize]="1024 * 5"
            [allowedTypes]="['png', 'jpg', 'jpeg', 'pdf']"
            (select)="onFileSelect($event, i)"
            (remove)="onFileRemove(i)"
            class="d-block w-100"
          >
            <input
              #file
              type="file"
              class="input"
              required
              (click)="markAsTouched(i)"
            />
            <ng-template #placeholder>
              <img
                src="assets/images/icons/upload-document.svg"
                alt="upload document icon"
              />
              <div
                class="text-primary pt-2 text-sm"
                i18n="@@support.documentsTickets.documents"
              >
                Document *
              </div>
            </ng-template>
          </file-uploader>
        </div>
      </div>
      <small
        i18n="@@support.required"
        class="text-danger"
        *ngIf="documents.at(i)?.errors?.required && documents.at(i)?.touched"
        >* This field is required.</small
      >
    </ng-container>
  </div>
  <button
    class="btn btn-add my-2"
    (click)="addFile()"
    type="button"
    i18n="@@support.documentsTickets.addNewDocuments"
  >
    + add new document
  </button>

  <form-field
    class="front mb-0 textarea"
    label="Ticket Message *"
    i18n-label="@@support.message.required.label"
  >
    <textarea
      formControlName="message"
      placeholder="Enter your ticket message"
      rows="5"
      required
      i18n-placeholder="@@support.message.placeholder"
    ></textarea>
  </form-field>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="message?.errors?.required && message?.touched"
    >* This field is required.</small
  >
</div>
